import { useParams } from "react-router-dom";
import { PersonWorkspace } from "@/components/People/PersonWorkspace";
import { directoryHref } from "@/lib/atwDirectoryHost";

export function PersonDetailPage() {
  const params = useParams();
  const userId = decodeURIComponent(params.userId || "").trim();
  if (!userId) {
    return <p className="text-sm text-rose-700">Missing person id.</p>;
  }
  const encoded = encodeURIComponent(userId);
  return (
    <PersonWorkspace
      personApiPath={`/api/directory/people/${encoded}`}
      backHref={directoryHref("/people")}
      backLabel="People"
      mailAdminHref={`https://admin.mail.atw.net/users/${encoded}`}
    />
  );
}
